import { render, staticRenderFns } from "./RichTextPreview.vue?vue&type=template&id=e8f33fb4"
import script from "./RichTextPreview.vue?vue&type=script&lang=js"
export * from "./RichTextPreview.vue?vue&type=script&lang=js"
import style0 from "./RichTextPreview.vue?vue&type=style&index=0&id=e8f33fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports